// Libraries
import React, { useState, useEffect, useRef } from 'react';
import { Field } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Component
import {
    FormElems,
    Popup,
    AddAggregator,
    AddFranchise,
    AddMLE,
    AddPartner
} from '../../components/';

import {
    createEntityError,
    fetchEntityListRequest,
    fetchEntityHierarchyRequest,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';

const RoleType = props => {
    const { data } = props;
    if (data.type === 'AGGREGATOR') {
        return <AddAggregator {...props} />;
    } else if (data.type === 'FRANCHISE') {
        return <AddFranchise {...props} />;
    } else if (data.type === 'PARTNER') {
        return <AddPartner {...props} />;
    }

    return <AddMLE {...props} />;
};

RoleType.propTypes = {
    data: PropTypes.object,
};

const getParentDetails = (entityType, entitySelectedValue) => {
    if (entityType.toUpperCase() === 'MLE') {
        let entityType = 'FRANCHISE';
        if (entitySelectedValue.aggregator && entitySelectedValue.franchise) {
            return {
                value: entitySelectedValue.franchise,
                type: entityType,
            };
        } else if (
            entitySelectedValue.aggregator &&
            !entitySelectedValue.franchise
        ) {
            entityType = 'AGGREGATOR';
            return {
                value: entitySelectedValue.aggregator,
                type: entityType,
            };
        } else if (
            !entitySelectedValue.aggregator &&
            entitySelectedValue.franchise
        ) {
            return {
                value: entitySelectedValue.franchise,
                type: entityType,
            };
        }
    } else if (entityType.toUpperCase() === 'FRANCHISE') {
        const entityType = 'AGGREGATOR';
        if (entitySelectedValue.aggregator) {
            return {
                value: entitySelectedValue.aggregator,
                type: entityType,
            };
        }
    }
    return null;
};

const AddRole = props => {
    const [showFilter, setShowFilter] = useState(false);
    const {
        data,
        onRoleSelect,
        actions,
        isViewMode,
        entityValue,
        entitySelectedValue,
        setEntityValues,
        id,
        hierarchyLoader,
        refreshValue,
    } = props;
    const refreshRef = useRef(false);

    const handleOpenAddRole = () => {
        setShowFilter(true);
    };

    const handleCloseAddRole = (onSuccessClose, entityType) => {
        actions.createEntityError({
            error: {},
        });
        if (onSuccessClose && entityType) {
            const parentDetails = getParentDetails(
                entityType,
                entitySelectedValue
            );
            if (parentDetails) {
                const { type, value } = parentDetails;
                actions.fetchEntityHierarchyRequest(
                    value,
                    'LOWER_COMPLETE',
                    type
                );
            } else {
                actions.fetchEntityListRequest(entityType);
            }
        }
        setShowFilter(false);
    };

    useEffect(() => {
        if (refreshValue && data.props.data && !refreshRef.current) {
            const originalData = data.props.data.find(
                item => item.entityCode === refreshValue
            );
            onRoleSelect(refreshValue, originalData, data.type);
            refreshRef.current = true;
        }
    }, [data, onRoleSelect, refreshValue]);

    return (
        <li className="form-section" id={id}>
            <Field
                name={data.name}
                {...data.props}
                input={false}
                wrapperClass={data.name}
                loader={hierarchyLoader}
                component={FormElems.SearchSelectEnhanced}
                selected={entityValue || refreshValue}
                handleChange={(value, originalData) => {
                    onRoleSelect(value, originalData, data.type);
                    const values = entitySelectedValue;
                    values[data.name] = value;
                    setEntityValues(values);
                }}
                disabled={isViewMode}
            />

            <FormElems.Button
                buttonType="secondary"
                customClass="add-action"
                text="ADD"
                type="button"
                handleClick={!isViewMode ? handleOpenAddRole : undefined}
            />
            <Popup
                title={data.popupTitle}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                closePopup={handleCloseAddRole}
            >
                <RoleType data={data} closePopup={handleCloseAddRole} />
            </Popup>
        </li>
    );
};

AddRole.propTypes = {
    actions: PropTypes.object,
    data: PropTypes.object,
    onRoleSelect: PropTypes.func,
    isViewMode: PropTypes.bool,
    entityValue: PropTypes.string,
    entitySelectedValue: PropTypes.object,
    setEntityValues: PropTypes.func,
    id: PropTypes.string,
    hierarchyLoader: PropTypes.number,
    refreshValue: PropTypes.string,
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createEntityError,
            fetchEntityListRequest,
            fetchEntityHierarchyRequest,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRole);
